import { ShiftSwapsReducerState } from './type';

export const getDefaultState = (): ShiftSwapsReducerState => ({
  swaps: {},
  undoQueue: [],
});
